/* eslint-disable react/jsx-indent */
/* eslint-disable max-len */
import React from "react";
import $ from "jquery";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";

import { logPageView } from "../../../AppUtil/analytics";
import Header from "./Header";
import StaticBody from "./StaticBody";
import Signatures from "./Signatures";
import Disclaimer from "./Disclaimer";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  button: {
    borderRadius: "100px !important",
    width: "80%",
    padding: "1rem",
    color: "#fff",
    backgroundColor: " #25b78d",
    border: "2px solid #76c4ee",
    boxShadow: "none",
    textAlign: "center",
    fontFamily: "'Raleway', sans-serif",
    fontSize: "15px",
    fontStyle: "normal",
    fontWeight: "700",
  },
});

class LoanAgreementGuarantorLender extends React.Component {
  genrateButton = (name, action) => {
    const { classes } = this.props;
    return (
      <Grid
        item
        xs={6}
        sm={6}
        spacing={2}
        align="center"
        justify="center"
        style={{ padding: "2rem" }}
      >
        <Button
          className={classes.button}
          style={
            name === "download"
              ? {
                  backgroundColor: "#25b78d",
                  color: "#fff",
                }
              : {
                  backgroundColor: "#fff",
                  color: "#000",
                }
          }
          aria-label="add"
          onClick={action}
          type="submit"
          id={name === "back" ? "download" : ""}
        >
          {this.props.t(`buttons.${name}`)}
        </Button>
      </Grid>
    );
  };
  print() {
    const printBlock = $(this).parents(".print").siblings(".print");
    printBlock.hide();
    window.print();
    printBlock.show();
  }
  componentDidMount() {
    logPageView("/app/loan-agreement-doc"); // NOSONAR
    window.scrollTo(0, 0);
  }
  trimTheText = (text) => {
    return text.trim();
  };

  render() {
    const { t } = this.props;
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Grid className={classes.paper} container justify="center">
          <Grid item md={8}>
            <Paper elevation={3}>
              <h3 style={{ padding: "2rem 2rem 0" }}>Accession</h3>
              <div className="printArea" id="pdf-container">
                <center>
                  <p className="no-print">
                    <strong>
                      {t("loan_agreement_guarantor_lender.main_heading")}
                    </strong>
                  </p>
                  <p>
                    <strong>
                      {t(
                        "loan_agreement_guarantor_lender.loan_agreement_promissory_note"
                      )}
                    </strong>
                  </p>
                </center>

                <Header
                  _currentUserId={this.props._currentUserId}
                  hashedSupportedStates={this.props.hashedSupportedStates}
                  loanObject={this.props.loanObject}
                />

                <StaticBody />
                <br />

                <Signatures />
                <br />
                <div>
                  <p>
                    <strong>
                      {t("label.lenders_sign")}{" "}
                      ____________________________________
                    </strong>
                  </p>
                </div>
                <div>
                  <p>
                    <strong>
                      {t("label.guarantor_sign")}{" "}
                      ____________________________________
                    </strong>
                  </p>
                </div>
                <br />
                <div>
                  <p>
                    <strong>{t("label.witness_sign")}</strong>{" "}
                    <span className="signs">LendAmi </span>
                  </p>
                </div>
                <div>
                  <p>
                    <strong>
                      {t("label.witness_name")}{" "}
                      ____________________________________
                    </strong>
                  </p>
                </div>
                <div>
                  <p>
                    <strong>
                      {t("label.witness_address")}{" "}
                      _____________________________________________
                    </strong>
                  </p>
                </div>
                <br />
                <Disclaimer />
              </div>
              <div className="container no-print clearfix">
                <Grid
                  className="no-shadow"
                  alignItems="center"
                  justify="center"
                  spacing={2}
                  container
                  id="reduce-width"
                >
                  {this.genrateButton("back", this.props.closeLoanAgreement)}
                  {this.genrateButton("download", this.props.onGeneratePdf)}
                </Grid>
              </div>
            </Paper>
          </Grid>
        </Grid>
      </div>
    );
  }
}
export default withStyles(styles)(
  withTranslation()(LoanAgreementGuarantorLender)
);
